(function (window, document) {
  'use strict';

  function init(root) {
    if (!root || root.dataset.awReady === 'true') return;
    root.dataset.awReady = 'true';

    const instruction = root.querySelector('[data-aw-print-instructions]');
    const scaleWrap = root.querySelector('[data-aw-scale-wrap]');
    const scale = root.querySelector('[data-aw-scale-select]');
    const otherWrap = root.querySelector('[data-aw-other-wrap]');
    const other = root.querySelector('[data-aw-other-text]');

    if (!instruction || !scaleWrap || !scale || !otherWrap || !other) return;

    function update() {
      const instructionValue = instruction.value;
      const showScale = instructionValue === 'Scale';

      scaleWrap.hidden = !showScale;
      scale.disabled = !showScale;
      scale.required = showScale;

      if (!showScale) {
        scale.value = '';
      }

      const showOther =
        instructionValue === 'Other' ||
        (showScale && scale.value === 'Other');

      otherWrap.hidden = !showOther;
      other.disabled = !showOther;
      other.required = showOther;

      if (!showOther) {
        other.value = '';
      }

      document.dispatchEvent(new CustomEvent('alwan:file-instructions:update', {
        detail: {
          valid: isValid(),
          instruction: instructionValue,
          scale: scale.value
        }
      }));
    }

    function isValid() {
      if (instruction.value === 'Scale' && !scale.value) return false;

      if (
        instruction.value === 'Other' ||
        (instruction.value === 'Scale' && scale.value === 'Other')
      ) {
        return other.value.trim() !== '';
      }

      return true;
    }

    instruction.addEventListener('change', update);
    scale.addEventListener('change', update);
    other.addEventListener('input', update);

    update();

    window.AlwanFileInstructions = {
      isValid
    };
  }

  function initAll() {
    document.querySelectorAll('[data-aw-file-instructions]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})(window, document);
